import { Gender } from "../../../../Wrap/Constants/Enums/Domain/Gender";
import { Title } from "../../../../Wrap/Constants/Enums/Title";
import { TitleMap } from "./TitleMap";

export class GenderMap {
    public static getString(Gender: Gender): string {
        return this.getMap().get(Gender);
    }

    public static getEnum(Gender: string): Gender {
        const map = this.getMap();

        let result: Gender;

        map.forEach((value: string, index: Gender) => {
            if (value === Gender) {
                result = index;
            }
        });

        return result;
    }

    public static getArray(): Gender[] {
        const options = [Gender.Female, Gender.Male];
        return options;
    }

    private static getMap(): Map<Gender, string> {
        const map = new Map<Gender, string>();
        map.set(Gender.NotSpecified, "Not specified");
        map.set(Gender.Female, "Female");
        map.set(Gender.Male, "Male");       
        return map;
    }

    public static checkGenderValidation(value: Gender, title: Title): boolean {
        const femaleSalutations = [Title.Mrs, Title.Ms, Title.Miss, Title.Lady];
        const maleSalutations = [Title.Mr, Title.Sir, Title.Lord, Title.Father];
        let isValid = true;
        if (title) {
            switch (value) {
                case Gender.Female:
                    isValid = !maleSalutations.some((salutation) => salutation === title);
                    break;
                case Gender.Male:
                    isValid = !femaleSalutations.some((salutation) => salutation === title);
                    break;
            }
        }
        return isValid;
    }
}
